import { InputSkeleton, TextareaSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  RightSection,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import { RichTextLoader } from '@/_containers/inputs/rich-text';

import { ProfileRightSectionLoading } from './right-section';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} withBreadcrumb />

      <Container>
        <LeftSection>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <TextareaSkeleton className="col-span-12" />
              <RichTextLoader className="col-span-12" withLabel />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
        <RightSection>
          <ProfileRightSectionLoading />
        </RightSection>
      </Container>
    </ContainerLayout>
  );
}
